class ServerRequest {
  API_URL_AUTH = 'https://api.avoka-do.com/api/auth';
  API_URL_AUTHORIZE_USER = 'https://api.avoka-do.com/api/authForm';
  API_URL_UPDATE_USER = 'https://api.avoka-do.com/api/updateForm';
  API_URL_SEND_WORKOUT_DATA = 'https://api.avoka-do.com/api/workoutFeedback';
  API_URL_SEND_WATER_BALANCE_DATA = 'https://api.avoka-do.com/api/waterBalance';
  API_KEY = 'JNuNVUXLPj0iKV99';


  getHeaders() {
    return {
      'api-key': this.API_KEY,
      "Content-Type": 'application/json',
    }
  };


  async authenticateUserData(phoneNumber) {
    let data = {
      geo: "KW",
      aggregator: "MobiMind",
      number: phoneNumber,
      service: "avocado",
    };
    const response = await fetch(this.API_URL_AUTH, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(data),
    });
    return response;
  };


  async authorizeUserProfile(name, gender, weight, phoneNumber) {
    let userProfileData = {
      geo: "KW",
      aggregator: "MobiMind",
      userName: name,
      userGender: gender,
      userWeight: weight,
      number: phoneNumber,
    };
    const response = await fetch(this.API_URL_AUTHORIZE_USER, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(userProfileData),
    });
    return response;
  };


  async updateUserProfile(name, gender, weight, userHash) {
    let userProfileData = {
      userProfileData: {
        userName: name,
        userGender: gender,
        userWeight: weight,
        userHash: userHash,
      }
    };
    const response = await fetch(`${this.API_URL_UPDATE_USER}?user_hash=${userHash}`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(userProfileData),
    })
    return response;
  };


  async sendWorkoutFeedbackData(workoutData, userHash) {
    let workoutFeedbackData = {
      workoutFeedbackData: workoutData,
    };
    const response = await fetch(`${this.API_URL_SEND_WORKOUT_DATA}?user_hash=${userHash}`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(workoutFeedbackData),
    })
    return response;
  };


  async sendWaterBalanceData(
    challengeAutoUpdating,
    allChallengesStatusBegun,
    allChallengesStatusDaily,
    allChallenges,
    waterBalanceUserData,
    userHash) {
    const waterBalanceData = {
      waterBalanceData: {
        ...waterBalanceUserData,
        ...challengeAutoUpdating,
        ...allChallengesStatusBegun,
        ...allChallengesStatusDaily,
        ...allChallenges,
      },
      userHash: userHash,
    };
    const response = await fetch(`${this.API_URL_SEND_WATER_BALANCE_DATA}?user_hash=${userHash}`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(waterBalanceData),
    })
    return response;
  };
}

export default new ServerRequest();